<template>
    <div>
        <v-fade-transition>
            <template>
                <div v-show="Bookview == false">
                    <v-alert class="text-center mt-12" dark color="primary">
                        LIBRO VIRTUAL DE INTELIGENIO
                    </v-alert>
                    <v-expand-transition>
                        <div v-show="nivelesView">
                            <v-row class="d-flex justify-center">
                                <v-col cols="12">
                                    <ButtonComp v-if="loginSession.id_perfil == 2" normal-button
                                        @click="modalAdd = true, limpiarFormulario()" iconBut=" fa-solid fa-upload"
                                        text-button="Cargar archivos" />
                                    <ComunDialogComp v-model="modalAdd" @close-modal="modalAdd = false, limpiarFormulario(), limpiarProgressBar()"
                                        title="Información del Libro" maxWidth="600">

                                        <template v-slot:body >
                                           
                                            <v-form ref="form">
                                                <v-select label="Nivel" v-model="bookNivel" :items="niveles"
                                                    item-text="desc_nivel" item-value="id_nivel_colegio"
                                                    @change="getGrados(bookNivel)" :rules="validationRules.validateCampo"
                                                    return-object
                                                    ref="bookNivel"
                                                    ></v-select>

                                                <v-select label="Grado" v-model="bookGrado" :items="grados"
                                                    item-text="desc_grado" item-value="id"
                                                    :rules="validationRules.validateCampo" return-object
                                                    ref="bookGrado"
                                                    ></v-select>

                                                <v-select label="Área del Libro" v-model="bookArea" :items="areas"
                                                    item-text="desc_area" item-value="id"
                                                    :rules="validationRules.validateCampo" return-object
                                                    ref="bookArea"
                                                    ></v-select>
                                            
                                                <v-select label="Tipo de libro" v-model="tipoDeLibro" :items="totalTiposDeLibros"
                                                    item-text="desc_tipoDeLibro" item-value="id"
                                                    :rules="validationRules.validateCampo" return-object
                                                    ref="tipoDeLibro"
                                                    ></v-select>
                                                
                                                <v-select label="Pertenece a:" v-model="perfilAquienPerteneceElLibro" :items="totalPerfilesAquienPerteneceElLibro"
                                                    item-text="desc_perfilAquienPerteneceElLibro" item-value="id"
                                                    :rules="validationRules.validateCampo" return-object
                                                    ref="perfilAQuienPerteneceElLibro"
                                                    ></v-select>
                                          

                                                <div>
                                                    <v-expand-transition>
                                                        <v-row dense v-show="todosSelectsCompletos">
                                                            <v-col cols="12" md="6">
                                                                <v-card outlined>
                                                                    <v-card-title class="d-flex text-subtitle-2">
                                                                        Seleccionar un libro
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-icon class="ml-2" color="primary" small
                                                                                    v-bind="attrs" v-on="on">
                                                                                    fas fa-info-circle
                                                                                </v-icon>
                                                                            </template>
                                                                            <div style="max-width: 200px;">
                                                                                <span>Seleccionar un
                                                                                    libro de una carpeta por
                                                                                    encima del
                                                                                    directorio que almacene los archivos
                                                                                    correspondientes al
                                                                                    libro</span>
                                                                            </div>
                                                                        </v-tooltip>
                                                                    </v-card-title>
                                                                    <v-card-text>
                                                                        <input id="btnoriginal" ref="fileInput"
                                                                            @change="openConfirmDialog" type="file"
                                                                            webkitdirectory directory multiple
                                                                            style="display:none" value="Adjuntar documento">
                                                                        <button id='botonpersonal' class="mr-2"
                                                                            @click="handleButtonClick" :disabled="isBtnAvailable">Adjuntar
                                                                            carpeta</button>
                                                                        <div>
                                                                            <small id='tagsmall'>No hay archivos
                                                                                adjuntos</small>
                                                                        </div>
                                                                    </v-card-text>
                                                                </v-card>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <v-select dense v-model="bookPerfil" :items="perfiles"
                                                                    label="Perfiles" multiple chips
                                                                    item-text="desc_rol_licencia"
                                                                    hint="Perfiles que pueden visualizar el libro"
                                                                    persistent-hint></v-select>
                                                            </v-col>
                                                        </v-row>

                                                    </v-expand-transition>
                                                </div>
                                                
                                                <v-col v-if="loginSession.id_perfil == 2 && chargingBarProgress" class="mt-3">
                                                    <!-- Barra de progreso total -->
                                                    <v-progress-linear :value="uploadProgress" color="light-blue" class="pb-3" height="14" striped>
                                                        <strong>{{ uploadProgress }}%</strong>
                                                    </v-progress-linear>

                                                    <v-row justify="center" class="d-flex flex-column mt-5">
                                                        <!-- Mostrar el conteo de archivos cargados frente al total -->
                                                        <v-chip dark class="mb-2 justify-center primary">{{ singleFile }} Carga individual / {{ totalFilesUpload }} Carga total</v-chip>
                                                        <v-chip dark class="mb-2 justify-center primary">{{ uploadedFiles }} / {{ totalFiles }} Archivos cargados</v-chip>
                                                    </v-row>
                                                </v-col>

                                            </v-form>
                                        </template>

                                        <template v-slot:actions>
                                            <v-spacer></v-spacer>
                                            <!-- <ButtonComp class="mx-2" textButton="Confirmar" /> -->
                                            <ButtonComp @click="modalAdd = false, limpiarFormulario(), limpiarProgressBar()"  textButton="Cancelar"
                                                classColor="red" />
                                        </template>
                                   
                                    </ComunDialogComp>

                                    
                                </v-col>




                                <v-col cols="auto" v-for="(nivel, index) in niveles" :key="index">
                                    <v-card class="my-card" @click="getBooks(nivel.id_nivel_clickone)">
                                        <v-card-text>
                                            <v-img width="200"
                                                :src="nivel.id_nivel_clickone == 4 ?
                                                    'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/Img_no_disponible/INICIAL.png' : nivel.id_nivel_clickone == 5 ?
                                                        'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/Img_no_disponible/PRIMARIA.png' :
                                                        'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/Img_no_disponible/SECUNDARIA_1.png'">
                                            </v-img>
                                        </v-card-text>
                                        <v-card-title class="d-flex justify-center primary--text">
                                            {{ nivel.desc_nivel }}
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                    <v-expand-transition>
                        <div v-show="gradosView">
                            <v-row class="d-flex justify-center">
                                <v-col cols="12" class="d-flex justify-start">
                                    <ButtonComp text-button="Volver" @click="closegradosView()" classColor="red"
                                        iconBut="fas fa-arrow-left" />
                                </v-col>

                                <template v-if="books.length > 0">
                                    <v-col cols="auto" v-for="(item, index) in books" :key="index">
                                        <v-card class="my-card">
                                            <v-card-text @click="getFramebook(item)">
                                                <v-img width="200" height="200" :src="item.path_portada.includes('flipbook.pdf-thumb') ? baseUrl + '/' + item.path_portada: 'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroGeneral/Img_no_disponible/IMAGEN+NO+DISPONIBLE.png' ">
                                                </v-img>
                                            </v-card-text>
                                            <v-card-title class="d-flex justify-center primary--text">
                                                {{ item.area }}
                                            </v-card-title>
                                            <v-card-subtitle class="d-flex justify-center">
                                                {{ item.desc_grado }}
                                            </v-card-subtitle>
                                            <v-card-subtitle class="d-flex justify-center">
                                                <v-list style="max-width: 200px;" dense
                                                    v-if="loginSession.id_perfil == 2">
                                                    <v-list-group :value="false" no-action sub-group>
                                                        <template v-slot:activator>
                                                            <v-subheader>Perfiles relacionados</v-subheader>
                                                        </template>
                                                        <v-list-item-group>
                                                            <v-list-item v-for="(item, i) in item.perfil_params"
                                                                :key="i">
                                                                <v-list-item-content>
                                                                    <v-list-item-subtitle>{{ item
                                                                        }}</v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list-item-group>
                                                    </v-list-group>


                                                </v-list>

                                            </v-card-subtitle>
                                        </v-card>
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col cols="auto">
                                        <v-card outlined>
                                            <v-card-text width="200" style="min-height: 400px;"
                                                class="d-flex justify-center align-center">
                                                No se encontraron libros disponibles
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </template>

                            </v-row>
                        </div>
                    </v-expand-transition>
                </div>
            </template>

        </v-fade-transition>

        <template v-if="Bookview == true">
            <v-row dense>
                <v-col cols="12">
                    <ButtonComp text-button="Volver" @click="closeFramebook()" classColor="red"
                        iconBut="fas fa-arrow-left" />
                </v-col>
                <v-col cols="12">
                    <v-card-title class="d-flex justify-center py-2">{{ Bookviewframe.area }}</v-card-title>
                </v-col>
            </v-row>
            <iframe name="simuladoresphet" height="900" width="100%" frameborder="0"
                :src="baseUrl + '/' + Bookviewframe.path_contenido" allowfullscreen mozallowfullscreen
                webkitallowfullscreen></iframe>
            <!-- {{ Bookviewframe }} -->



        </template>


    </div>
</template>
<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from '../../../helpers/axios'
import io from 'socket.io-client';
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';
import { mapMutations } from 'vuex';
import { validationRules } from '../../../helpers/validatorHelpers';

export default {

    components: {
        ButtonComp,
        ComunDialogComp,
    },

    data: () => ({

        loginSession: sessionStorage,
        estudianteData: {},
        nivelesView: true,
        gradosView: false,
        Bookview: false,
        modalAdd: false,
        // confirmd: false,
        baseUrl: BUCKET_ORIGIN_SPACE,
        niveles: [],
        perfiles: [],
        grados: [],
        books: [],
        areas: [],
        Bookviewframe: [],
        selectedFiles: [],
        nivelesSeleccionado: false,
        gradosSeleccionado: false,
        areasSeleccionado: false,
        bookNivel: '',
        bookGrado: '',
        bookArea: '',
        bookPerfil: '',
        tipoDeLibro: '',
        totalTiposDeLibros: [],
        perfilAquienPerteneceElLibro: '',
        totalPerfilesAquienPerteneceElLibro: [],
        //Variables Para el progressBar
        chargingBarProgress: false,
        totalFiles: 0,
        uploadedFiles: 0,
        uploadProgress: 0,
        individualFileProgress: [],
        socket: null,
        dataProgressBar: [],
        isBtnAvailable: false,
        sizeFiles:[],
        singleFile: 0,
        totalFilesUpload: 0,
    }),


    mounted() {
        // this.getNivelEstudiante();
        this.loadMain(); 
        this.socket = io(API_URL);
        this.socket.on('updateBar',(data) => {
            this.dataProgressBar.push({...data})
            this.loadMain();
        });
       
    },
    beforeDestroy() {
        this.socket.off('update');
        this.socket.disconnect();
    },
    computed: {
        validationRules() {
            return validationRules
        },

        todosSelectsCompletos() {
            return this.nivelesSeleccionado && this.gradosSeleccionado && this.areasSeleccionado && this.tipoDeLibro && this.perfilAquienPerteneceElLibro;
        }
    },

    watch: {
        // Observadores para los cambios en los modelos de los selects
        'bookNivel': function (newVal) {
            this.nivelesSeleccionado = !!newVal;
        },
        'bookGrado': function (newVal) {
            this.gradosSeleccionado = !!newVal;
        },
        'bookArea': function (newVal) {
            this.areasSeleccionado = !!newVal;
        },
       
    },

    //metodos
    methods: {

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations("mensajeSis", ["setEnviarMens"]),

        async loadMain() {
            this.getniveles();
            this.asignacionVariables();
        },

        openConfirmDialog(event) {
            document.getElementById('tagsmall').innerText = document.getElementById('btnoriginal').files[0]['name'];
            this.selectedFiles = event.target.files;
            this.handleFileUpload(event);
        },


        async getniveles() {
            try {
                if (this.loginSession.descripcion_perfil == 'Webmaster') {
                    let response = await axios.get(`/libroVirtual/${this.loginSession.id_colegio}`);
                    this.niveles = response.data.niveles;
                    this.perfiles = response.data.perfiles
                } else if (this.loginSession.licencia_perfil == 'familiar') {
                    let response = await axios.get(`/libroVirtual/getFamiliar/${this.loginSession.id}`)
                    this.niveles = response.data;
                } else if (this.loginSession.licencia_perfil == 'estudiante') {
                    let response = await axios.get(`/libroVirtual/getAlumno/${this.loginSession.id}`)
                    this.niveles = response.data.nivel;
                    let basebooks = response.data.book;

                    let filteredBooks = basebooks.filter(libro => {
                        return libro.perfil_params.some(perfilLibro => this.loginSession.licencia_perfil.includes(perfilLibro));
                    });

                    this.books = filteredBooks;
                }

            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        async getGrados(id) {
            try {
               
                let idColegio = id.id_nivel_colegio
                let response = await axios.get(`/libroVirtual/grados/${idColegio}`);
                this.grados = response.data.grados;
                this.areas = response.data.areas;
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        async getBooks(id_nivel) {
            this.nivelesView = false;
            this.gradosView = true;
            try {
                if (this.loginSession.licencia_perfil != 'estudiante' || this.loginSession.licencia_perfil == 'null') {
                    let response = await axios.get(`/libroVirtual/getBooks/${id_nivel}`);
                    let basebooks = response.data
                    if (this.loginSession.licencia_perfil == 'null') {
                        this.books = basebooks
                    } else {
                        let filteredBooks = basebooks.filter(libro => {
                            return libro.perfil_params.some(perfilLibro => this.loginSession.licencia_perfil.includes(perfilLibro));
                        });
                        this.books = filteredBooks;
                    }
                }

            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }

        },

        handleButtonClick(event) {
            event.preventDefault(); // Evita que el formulario se envíe
            document.getElementById('btnoriginal').click(); // Simula el clic en el input file
            this.limpiarProgressBar();
            
        },

        async getFramebook(item) {
            this.gradosView = false
            this.nivelesView = false
            this.Bookview = true;
            this.Bookviewframe = item
        },

        async asignacionVariables(){
            this.totalTiposDeLibros = [
                {
                    id: "1",
                    desc_tipoDeLibro: "Libro virtual"
                },
                {
                    id: "2",
                    desc_tipoDeLibro: "Libro de actividades"
                }
            ];
            this.totalPerfilesAquienPerteneceElLibro = [
                {
                    id: "1",
                    desc_perfilAquienPerteneceElLibro: "Docente"
                },
                {
                    id: "2",
                    desc_perfilAquienPerteneceElLibro: "Estudiante"
                }
            ];
        },

        async handleFileUpload(event) {
           
            try {
               
                this.isBtnAvailable = true;
                this.chargingBarProgress = true;
                const files = event.target.files;
                this.totalFiles = files.length;
         
                const formData = new FormData();
                
                for (const file of files) {
                    this.sizeFiles.push(file.size);
                    formData.append('subirArchivo[]', file);
                    formData.append('filePath[]', file.webkitRelativePath);
                }
               
                let params = {
                    bookNivel: this.bookNivel,
                    bookGrado: this.bookGrado,
                    bookArea: this.bookArea,
                    bookPerfil: this.bookPerfil,
                    tipoDeLibro: this.tipoDeLibro,
                    perfilAquienPerteneceElLibro: this.perfilAquienPerteneceElLibro,
                };
               
                formData.append('myDataKey', JSON.stringify(params));
                await axios.post("/libroVirtual/s3Upload", formData);

                this.upLoadProgressBar(this.dataProgressBar)
            
            } catch (error) {
                console.error('Error al subir archivos:', error);
                this.setEnviarMens({tipo: 'E', message: error.message, tiempo: null });
            }
        },



    async upLoadProgressBar(data) {
        let totalSizeFiles = 0;
        for (let i = 0; i < data.length; i++) {
          
            setTimeout(async() => {
              
                this.uploadProgress = Math.round(data[i].loaded * 100) / 100;
                this.uploadedFiles = data[i].archivosCargados;      
                this.singleFile = await this.formatFileSize(this.sizeFiles[i])
                this.totalFilesUpload  =  await this.formatFileSize(totalSizeFiles += this.sizeFiles[i])
              
            }, 1);

          
        }
        setTimeout(() => {
            // this.chargingBarProgress = false;
            // this.uploadProgress = 0;
            // this.uploadedFiles = 0;
            // this.totalFiles = 0;
            // this.individualFileProgress = [];
            // this.singleFile = 0;
            // this.totalFilesUpload = 0;
            this.$refs.fileInput.value = null;
            this.isBtnAvailable = false;
        }, 4000);
    },
   
    async formatFileSize(size) {
        const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        return `${(size / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
    },

        

        async limpiarFormulario() {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
             }
            this.chargingBarProgress = false;
            this.bookNivel = '';
            this.bookGrado = '';
            this.bookArea = '';
            this.tipoDeLibro = '';
            this.perfilAquienPerteneceElLibro = '';
            this.bookPerfil = [];
            this.uploadedFiles = 0;
            this.uploadProgress = 0;
            this.totalArchivos = 0;
            this.individualFileProgress = [];
            this.singleFile = 0;
            this.totalFilesUpload = 0;
            this.$refs.fileInput.value = null;
            setTimeout(() => {
                document.getElementById('tagsmall').innerText = 'No hay archivos adjuntos';
            }, 200);
        },

        async limpiarProgressBar() {
            this.chargingBarProgress = false;
            setTimeout(() => {
                document.getElementById('tagsmall').innerText = 'No hay archivos adjuntos';
            }, 200);
            this.uploadedFiles = 0;
            this.uploadProgress = 0;
            this.totalArchivos = 0;
            this.individualFileProgress = [];
            this.singleFile = 0;
            this.totalFilesUpload = 0;
            this.$refs.fileInput.value = null;
        },

        async closeFramebook() {
            this.Bookview = false
            this.gradosView = true
            this.Bookviewframe = []
        },

        async closegradosView() {
            this.nivelesView = true
            this.gradosView = false
            if (this.loginSession.licencia_perfil != 'estudiante') {
                this.books = []
            }

        },



    },

  

}
</script>



<style scoped>
.my-card {
    transition: transform 0.3s ease;
    cursor: pointer;
    /* border: 2px solid red; */
}

.my-card:hover {
    transform: scale(1.05);
}

.router-link {
    text-decoration: none;
}

#botonpersonal {
    font: caption;
    -webkit-appearance: button;
    background: black !important;
    color: white;
    border-color: black !important;
    border-radius: 12px;
    padding: 7px 10px;
}
</style>